import React, { Component, Fragment } from "react";

import Loader from "../../Loader/Loader";
import Section from "../../Section/Section";
import Summary from "../../Summery/Summary";

import "./ProductCategory.css";

class ProductCategory extends Component {
  state = {
    categories: [],
    summeries: [],
    isChildSummerySelected: false,
    categoriesLoading: true,
    parentData: {},
    functionButtonsLoading: false,
  };

  componentDidMount() {
    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
        });
      })
      .catch(this.catchError);
  }

  newResetHandler = () => {
    this.setState({
      categories: [],
      categoriesLoading: false,
      summeries: [],
      isChildSummerySelected: false,
    });

    const graphqlQuery = {
      query: `
        query {
          categories(depth: 1){
            code
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }
        this.setState({
          categories: [resData.data.categories],
          categoriesLoading: false,
          functionButtonsLoading: false,
        });
      })
      .catch(this.catchError);
  };

  addCategoryParentHandler = () => {
    var parentData = {};
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        if (this.state.categories[i][index].secondName !== "") {
          this.state.categories[i][index].name +
            " (" +
            this.state.categories[i][index].secondName +
            ")" ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentData = this.state.categories[i][index]);
        } else {
          this.state.categories[i][index].name ===
            this.state.summeries[this.state.summeries.length - 1] &&
            (parentData = this.state.categories[i][index]);
        }
      }
    }
    if (this.state.isChildSummerySelected) {
      this.props.productAddCategoryParentHandler(parentData);
    }
    this.setState({
      parentData: parentData,
      functionButtonsLoading: true,
    });
  };

  onSelectHandler = (parentData) => {
    var indexOfParent = 0;
    for (var i = 0; i < this.state.categories.length; i += 1) {
      for (let index = 0; index < this.state.categories[i].length; index++) {
        this.state.categories[i][index].code === parentData.code &&
          (indexOfParent = i);
      }
    }
    this.setState({
      categories: this.state.categories.slice(0, indexOfParent + 1),
      summeries: this.state.summeries.splice(
        indexOfParent,
        this.state.summeries.length
      ),
      functionButtonsLoading: false,
    });

    var summeryName = "";
    var isChildSummerySelected = false;
    for (var j = 0; j < this.state.categories.length; j += 1) {
      for (let index = 0; index < this.state.categories[j].length; index++) {
        if (this.state.categories[j][index].code === parentData.code) {
          summeryName = this.state.categories[j][index].name;
          if (this.state.categories[j][index].secondName) {
            summeryName =
              summeryName +
              " (" +
              this.state.categories[j][index].secondName +
              ")";
          }
          if (!this.state.categories[j][index].hasChildren) {
            isChildSummerySelected = true;
          }
        }
      }
    }

    if (summeryName !== "") {
      var joined = this.state.summeries.concat(summeryName);
      this.setState({
        summeries: joined,
        isChildSummerySelected: isChildSummerySelected,
      });
    }

    const graphqlQuery = {
      query: `
        query FetchSubCategories($parentCode: Int) {
          subCategories(parentCode: $parentCode){
            code  
            name 
            secondName
            enName
            dataTheme
            isUniformPackaging
            hasChildren
            displayOrder
          }
        }
      `,
      variables: {
        parentCode: parentData.code,
      },
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + this.props.token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(graphqlQuery),
    })
      .then((res) => {
        return res.json();
      })
      .then((resData) => {
        if (resData.errors) {
          throw new Error("مشکل در دریافت گروه کالایی!");
        }

        if (resData.data.subCategories.length) {
          var flag = false;
          for (var i = 0; i < this.state.categories.length; i += 1) {
            flag =
              this.state.categories[i][0].code ===
              resData.data.subCategories.code
                ? true
                : false;
          }
          if (!flag) {
            this.setState({
              categories: [
                ...this.state.categories,
                resData.data.subCategories,
              ],
              categoriesLoading: false,
            });
          }
        }
      })
      .catch(this.catchError);
  };

  catchError = (error) => {
    this.props.errorCatcher.bind(this, error);
  };

  render() {
    return (
      <Fragment>
        {this.state.categoriesLoading && (
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <Loader />
          </div>
        )}
        {this.state.categories.length <= 0 && !this.state.categoriesLoading ? (
          <p style={{ textAlign: "center" }}>گروه کالایی وجود ندارد.</p>
        ) : null}
        <div className="mn-content-categories" id="categoriesContainer">
          <div className="mn-content-categories__container">
            {!this.state.categoriesLoading &&
              this.state.categories.map((category, index) => (
                <Section
                  key={index}
                  categories={category}
                  onSelect={this.onSelectHandler.bind(this)}
                />
              ))}
          </div>
          <div className="mn-content-categories__summary">
            <Summary
              noneable={false}
              summeries={this.state.summeries}
              isChildSummerySelected={this.state.isChildSummerySelected}
              newResetHandler={this.newResetHandler.bind(this)}
              addCategoryParentHandler={this.addCategoryParentHandler.bind(
                this
              )} 
            />
          </div>
        </div>
      </Fragment>
    );
  }
} 

export default ProductCategory;

